import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'src/app/services/dashboard.service';
import { StripeService } from 'src/app/services/stripe.service';
import { ClientService } from '../../services/client.service';
import { ContextService } from '../../services/context.service';
import { DropboxService } from '../../services/dropbox.service';
import { ProcoreService } from '../../services/procore.service';

@Component({
	selector: 'app-form',
	templateUrl: './form.component.html',
	styleUrls: ['./form.component.css']
})
export class FormComponent implements OnInit {

	initialLoad = true;
	loading = true;
	loadingAttachments = false;
	loadingFilename = false;
	loadingContractSigner = true;
	loadingSubmit = false;
	loadingSubmitCancelled = false;
	loadingGeneratedFile = false;
	loadingUserLogout = false;
	loadingLaunchDashboard = false;
	loadingLaunchBillingPortal = false;
	requestSent = false;

	form!: UntypedFormGroup;
	signatures: any[] = [];
	//signature: any;
	userSignatures = [];

	errorResponse = '';
	signatureRequestExpired = false;

	helpMeDecide = false;

	existingSignatories: any[] = [];
	attachments: any[] = [];
	internalUsers: any[] = [];

	signerId = 0; // This should only be used for the ordering on the UI using the trackBy: trackSigners feature, not for the request ordering on the back-end

	uploadedDoc: any;
	useGeneratedFile = false;
	fileType = 'generated';
	templates = [];
	selectedTemplate: any;
	selectedTemplateOverlay: any;

	showDragDropBorder: boolean = false;

	ccList: any[] = [];

	//originalProcoreInfo: any;
	//procoreInfo: any;
	projectConfigs: any = {};

	showTemplateOverlaysExpanded = false;
	showCreateNewRequest = false;
	showCancelAndEditRequest = false;
	showHelp = false;
	showConfigure = false;
	showConfigureUser = false;
	showPrevious = false;
	showAllRequests = false;
	showMenuExpanded = false;
	showWaitingMessage = false;

	authMessage = '';

	isSubmittal = false;
	isSubmittalManager = false;

	isRfi = false;
	isRfiManager = false;

	isSigner = false;
	hasBallInCourt = false;

	folders = [];
	folderOptions = [];

	submitRetries = 0;
	twoZeroFourRetries = 0;

	currentTermDaysRemaining;

	constructor(
		private fb: UntypedFormBuilder,
		private clientService: ClientService,
		public contextService: ContextService,
		private dashboardService: DashboardService,
		private dropboxService: DropboxService,
		private procoreService: ProcoreService,
		private router: Router,
		private route: ActivatedRoute,
		private stripeService: StripeService
	) {
	}

	ngOnInit() {
		this.setDefaultProjectConfigs();
		for (const config of this.contextService.clientDetailProcore.projectConfigs) {
			console.log(config.configName);
			if (config.configName === 'allowDefaultLocationOverride') {
				console.log(config.configValue);
				this.projectConfigs[config.configName] = config.configValue === 'true';
				console.log(this.projectConfigs[config.configName]);
			} else {
				this.projectConfigs[config.configName] = config.configValue;
			}
		}

		this.initForm();

		// NOTE: Due to an issue in how the tokens are generated/re-generated, I can only call a single
		// endpoint that interacts with Dropbox Sign at first.  Must call the remaining calls after this has
		// completed to avoid a token error.
		this.retrieveUsers();

		this.retrieveFolders();
		this.retrieveSignatures();
		// this.retrieveDefaultCC();
		this.retrieveFilename();
		this.retrieveProcoreUserConfig();

		if (this.contextService.clientDetailProcore.enableMultipleAttachments) {
			this.retrieveAttachments();
		} else {
			this.attachments = [];
		}

		if (this.contextService.signatureCount.currentTermEndDate) {
			let currentDate: Date = new Date();
			let endDate: Date = new Date(this.contextService.signatureCount.currentTermEndDate);

			let timeDifference = endDate.valueOf() - currentDate.valueOf();

			this.currentTermDaysRemaining = Math.ceil(timeDifference / (1000 * 3600 * 24));
		}
	}

	reInit() {
		this.loading = true;
		this.loadingSubmitCancelled = false
		this.requestSent = false;
		this.loadingContractSigner = true;
		this.showCreateNewRequest = false;
		this.showCancelAndEditRequest = false;
		this.showMenuExpanded = false;
		this.showHelp = false;
		this.showConfigure = false;
		this.showPrevious = false;
		this.showAllRequests = false;
		this.showWaitingMessage = false;
		this.errorResponse = '';

		this.initForm();

		// This gets the updated signature count
		this.dropboxService.getDoesUserExistWithSignatureCounts(this.contextService.procoreUserInfo.email, this.contextService.procoreContextObject.context.company_id)
			.subscribe((response) => {
				if (response.signatures || response.dropboxSignUsername) {
					this.contextService.signatureCount = response;

					if (this.contextService.signatureCount.currentTermEndDate) {
						let currentDate: Date = new Date();
						let endDate: Date = new Date(this.contextService.signatureCount.currentTermEndDate);

						let timeDifference = endDate.valueOf() - currentDate.valueOf();

						this.currentTermDaysRemaining = Math.ceil(timeDifference / (1000 * 3600 * 24));
					}
				}

				this.retrieveFolders();
				this.retrieveSignatures();
				// this.retrieveDefaultCC();
				this.retrieveFilename();
				this.retrieveProcoreUserConfig();

				this.setTemplates(this.templates);
			}, (error) => {
				this.retrieveSignatures();

				this.setTemplates(this.templates);
			});
	}

	initForm() {
		this.form = this.fb.group({
			companyId: ['', []],
			projectId: ['', []],
			fileId: ['', []],
			userId: ['', []],
			itemId: ['', []],
			view: ['', []],
			route: ['', []],
			sentOn: [formatDate(new Date(), 'yyyy-MM-dd', 'en'), []],
			allowDecline: [false, []],
			allowReassign: [false, []],
			expirationDate: ['', []],
			dateOffset: [new Date().getTimezoneOffset(), []],
			fileLocation: ['default', []],
			signersList: this.fb.array([]),
			title: ['', []],
			subject: ['', []],
			message: ['', []],
			requesterEmail: [this.contextService.procoreUserInfo.email, []],
			ccEmails: ['', []]
		});
		this.signerId = 0;

		this.setFormFromContext();
	}

	setFormFromContext() {
		this.form.controls['companyId'].setValue(this.contextService.procoreContextObject.context.company_id, { emitEvent: true });
		this.form.controls['projectId'].setValue(this.contextService.procoreContextObject.context.project_id, { emitEvent: true });
		this.form.controls['fileId'].setValue(this.contextService.procoreContextObject.context.file_id, { emitEvent: true });
		this.form.controls['userId'].setValue(this.contextService.procoreContextObject.context.user_id, { emitEvent: true });
		this.form.controls['itemId'].setValue(this.contextService.procoreContextObject.context.id, { emitEvent: true });
		this.form.controls['view'].setValue(this.contextService.procoreContextObject.context.view, { emitEvent: true });
		this.form.controls['route'].setValue(this.contextService.procoreContextObject.context.route, { emitEvent: true });

		if (this.contextService.procoreUserConfig?.dropboxSignDefaultSubject) {
			this.form.controls['subject'].setValue(this.contextService.procoreUserConfig.dropboxSignDefaultSubject, { emitEvent: true });
		} else {
			this.form.controls['subject'].setValue(this.contextService.clientDetailProcore.dropboxSignDefaultSubject, { emitEvent: true });
		}

		if (this.contextService.procoreUserConfig?.dropboxSignDefaultMessage) {
			this.form.controls['message'].setValue(this.contextService.procoreUserConfig.dropboxSignDefaultMessage, { emitEvent: true });
		} else {
			this.form.controls['message'].setValue(this.contextService.clientDetailProcore.dropboxSignDefaultMessage, { emitEvent: true });
		}

		// this.form.controls['ccEmails'].setValue(this.contextService.clientDetailProcore.dropboxSignDefaultCC, { emitEvent: true });
	}

	retrieveProcoreUserConfig() {
		let procoreUserConfig = {
			'procoreUserId': this.contextService.procoreUserInfo.procoreUserId,
			'dropboxSignDefaultSubject': '',
			'dropboxSignDefaultMessage': '',
			'dropboxSignDefaultCC': ''
		}
		this.contextService.procoreUserConfig = procoreUserConfig;

		this.clientService.getProcoreUserConfigByCompanyId(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, this.contextService.procoreIsSandbox)
			.subscribe({
				next: (response) => {
					if (response) {
						this.contextService.procoreUserConfig = response;
						if (this.contextService.procoreUserConfig.dropboxSignDefaultSubject) {
							this.form.controls['subject'].setValue(this.contextService.procoreUserConfig.dropboxSignDefaultSubject, { emitEvent: true });
						}
						if (this.contextService.procoreUserConfig.dropboxSignDefaultMessage) {
							this.form.controls['message'].setValue(this.contextService.procoreUserConfig.dropboxSignDefaultMessage, { emitEvent: true });
						}

						this.retrieveDefaultCC();
					}
				},
				error: (err) => {
					this.retrieveDefaultCC();
				}
			});
	}

	retrieveFilename() {
		this.loadingFilename = true;
		this.procoreService.getFilename(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreContextObject.context.view, this.contextService.procoreContextObject.context.route, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId).subscribe((result: any[]) => {
			console.log(result);
			this.loadingFilename = false;
		});
	}

	retrieveAttachments() {
		this.loadingAttachments = true;
		this.procoreService.getAttachments(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreContextObject.context.view, this.contextService.procoreContextObject.context.route, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId).subscribe((result: any[]) => {
			const files = result;
			for (const file of files) {
				if (this.contextService.clientDetailProcore.selectAllAttachments) {
					file.checked = true;
				} else {
					file.checked = false;
				}

				if (file.filename && this.isFileTypeValid(file.filename)) {
					file.title = file.filename;
					file.disabled = false;
				} else if (file.name && this.isFileTypeValid(file.name)) {
					file.title = file.name;
					file.disabled = false;
				} else {
					file.checked = false;
					file.disabled = true;
					file.title = "Invalid file extension"
				}
			}
			this.attachments = files;
			this.loadingAttachments = false;
		});
	}

	retrieveContractSigner() {
		this.loadingContractSigner = true;
		this.procoreService.getProjectContractSigner(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreContextObject.context.view, this.contextService.procoreContextObject.context.route, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe((response) => {
				if (response?.email) {
					if (this.contextService.clientDetailProcore.addContractSignerRole) {
						let signersArray = this.form.getRawValue()['signersList'];
						let signerUpdated = false;
						for (let i = 0; i < signersArray.length; i++) {
							if (this.contextService.clientDetailProcore.addContractSignerRole == signersArray[i].role) {
								this.updateSigner(response, this.form.getRawValue()['signersList'].length - 1);
								signerUpdated = true;
							}
						}
						if (!signerUpdated && signersArray.length > 0) {
							this.updateSigner(response, 0);
							signerUpdated = true;
						}
						if (!signerUpdated && signersArray.length == 0) {
							this.addSigner('');
							this.updateSigner(response, this.form.getRawValue()['signersList'].length - 1);
						}
					} else {
						const signers = this.form.get('signersList') as UntypedFormArray;
						if (signers.length > 0) {
							this.updateSigner(response, 0);
						} else {
							this.addSigner('');
							this.updateSigner(response, 0);
						}
					}
				}
				this.loadingContractSigner = false;
			});
	}

	retrieveFolders() {
		this.procoreService.getProjectFolders(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId).subscribe((folders: any[]) => {
			this.folders = folders;
			for (const folder of this.folders) {
				this.populateFolderOptions(folder, 0);
			}

			// IS THIS NEEDED?
			this.form.controls['fileLocation'].setValue(this.getDefaultFileLocation(), { emitEvent: true });
		});
	}

	retrieveSignatures() {
		console.log('retrieveSignatures');
		this.clientService.getSignaturesByProcoreContext(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreUserInfo.email)
			.subscribe((signaturesResult: any) => {
				if (signaturesResult) {
					this.signatures = signaturesResult;
				}

				console.log(signaturesResult);
				if (this.signatures.length > 0) {
					// This assumes the order is always correct.
					// Set the top entry to the signature.


					//Set the main signature
					const signatureResult = this.signatures[0];
					// this.signature = signatureResult.clientSignature;

					// // Set if its expired
					// if (this.signature.signatureExpirationDate) {
					// 	const expirationDate = new Date(this.signature.signatureExpirationDate);
					// 	if (new Date() > expirationDate) {
					// 		this.signatureRequestExpired = true;
					// 	}
					// }

					if (signatureResult.participants) {
						this.userSignatures
					}

					// This defaults the signers on the form in case of an edit
					if (signatureResult.signatures) {
						this.userSignatures = signatureResult.signatures;
						for (const signatureInfo of signatureResult.signatures) {
							let isInternal = false;
							for (const internalUser of this.internalUsers) {
								if (signatureInfo.signer_email_address === internalUser.email) {
									this.addSigner('');
									this.updateSigner(internalUser, this.form.getRawValue()['signersList'].length - 1);
									isInternal = true;
									break;
								}
							}
							// if (!isInternal) {
							// 	this.addSigner('');
							// 	this.updateSigner(signatureInfo.signer_email_address, signatureInfo.signer_name, this.form.getRawValue()['signersList'].length - 1);
							// }
							this.existingSignatories.push({
								'name': signatureInfo.signer_name,
								'email': signatureInfo.signer_email_address,
								'status': signatureInfo.status_code,
								'viewedAt': signatureInfo.last_viewed_at
							});
						}
					}
				}

				this.loading = false;
				this.initialLoad = false;
			}, (err) => {
				console.log(err);
				if (err.status === 400) {
					this.router.navigate(['/welcome/authenticate'], { queryParams: { error: true } });
				}
			});
	}

	retrieveDefaultCC() {
		this.ccList = [];

		if (this.contextService.procoreUserConfig.dropboxSignDefaultCC) {
			let ccArray = this.contextService.procoreUserConfig.dropboxSignDefaultCC.split(',');
			for (var i = 0; i < ccArray.length; i++) {
				// Trim the whitespace
				ccArray[i] = ccArray[i].replace(/^\s*/, "").replace(/\s*$/, "");

				let ccObj = {
					'number': 1,
					'email': ccArray[i]
				};

				this.ccList.push(ccObj);
			}
		} else if (this.contextService.clientDetailProcore.dropboxSignDefaultCC) {
			let ccArray = this.contextService.clientDetailProcore.dropboxSignDefaultCC.split(',');
			for (var i = 0; i < ccArray.length; i++) {
				// Trim the whitespace
				ccArray[i] = ccArray[i].replace(/^\s*/, "").replace(/\s*$/, "");

				let ccObj = {
					'number': 1,
					'email': ccArray[i]
				};

				this.ccList.push(ccObj);
			}
		}
	}

	retrieveUsers() {
		this.procoreService.getProjectUsers(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId).subscribe((result: any[]) => {
			console.log(result);
			this.internalUsers = result;
		});
	}

	// loadWindowContext() {
	// this.contextService.procoreIsSandbox = document.referrer.indexOf('sandbox') > -1 || document.referrer.indexOf('procore-dbs-dev.shakeit.ai') > -1;

	// window.addEventListener('message', (event) => {
	// 	if (event.data.context) {
	// this.contextService.procoreContextObject = event.data;

	// console.log('initial view: ' + this.contextService.procoreContextObject.context.view);
	// if (this.contextService.procoreContextObject.context.view === 'prime_contracts.change_orders.potential_change_orders.detail') { // TODO: remove this once prod manifest is fixed
	// 	this.contextService.procoreContextObject.context.view = 'prime_contracts.change_orders.detail';
	// }

	// console.log(this.contextService.procoreContextObject);
	// if (this.contextService.procoreContextObject.context.view === 'submittal_logs.detail') {
	// 	if (!this.authCode) {
	// 		this.startAuth(false);
	// 	}
	// 	this.isSubmittal = true;
	// } else if (this.contextService.procoreContextObject.context.view === 'rfi.detail') {
	// 	if (!this.authCode) {
	// 		this.startAuth(false);
	// 	}
	// 	this.isRfi = true;
	// } else if (this.contextService.procoreContextObject.context.view === 'inspections.detail' || this.contextService.procoreContextObject.context.view === 'correspondence.detail') {
	// 	if (!this.authCode) {
	// 		this.startAuth(false);
	// 	}
	// }
	// this.setFormFromContext();
	// this.getProcoreInfo();
	// if (this.openRequest) {
	// 	this.openStandaloneRequest();
	// }
	// this.procoreService.getAccountType(this.contextService.procoreContextObject.context.company_id).subscribe((accountType: string) => {
	// 	if (accountType === 'API') {
	// 		this.loadForm();
	// 		if (this.authCode && !this.openRequest && !this.isSubmittal && !this.isRfi && this.contextService.procoreContextObject.context.view !== 'inspections.detail' && this.contextService.procoreContextObject.context.view !== 'correspondence.detail') {
	// 			this.openConfigs();
	// 		}

	// 		this.getTemplates();
	// 		this.getFolders();
	// 	} else if (accountType === 'OAUTHG') {
	// 		this.procoreService.getDropboxSignUserExists(this.contextService.procoreContextObject.context.company_id).subscribe((exists: boolean) => {
	// 			if (exists) {
	// 				this.loadForm();
	// 				if (this.authCode && !this.isSubmittal && !this.isRfi && this.contextService.procoreContextObject.context.view !== 'inspections.detail' && this.contextService.procoreContextObject.context.view !== 'correspondence.detail') {
	// 					this.openConfigs();
	// 				}

	// 				this.getTemplates();
	// 				this.getFolders();
	// 			} else {
	// 				this.startDropboxSignAuth(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.company_id);
	// 			}
	// 		});
	// 	} else if (accountType === 'OAUTH') {
	// 		if (this.authCode) {
	// 			this.procoreService.getUserInfo(this.form.getRawValue()['companyId'], this.authCode, this.contextService.procoreIsSandbox).subscribe((result: any) => {
	// 				this.contextService.procoreUserInfo = result;


	/**
	 * 
	 * CHECK THE FOLLOWING
	 * 
	 */

	//this.form.controls['requesterEmail'].setValue(result.email, { emitEvent: true });


	// loadForm() {
	// 	this.procoreService.getUsers(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId).subscribe((result: any[]) => {
	// 		this.internalUsers = result;

	// 		this.procoreService.getSignatures(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreUserInfo?.email).subscribe((signaturesResult: any) => {
	// 			this.signatures = signaturesResult;
	// 			console.log(signaturesResult);
	// 			if (this.signatures.length > 0) {
	// 				const signatureResult = this.signatures[0];
	// 				this.signature = signatureResult.clientSignature;
	// 				if (this.signature.signatureExpirationDate) {
	// 					const expirationDate = new Date(this.signature.signatureExpirationDate);
	// 					if (new Date() > expirationDate) {
	// 						this.signatureRequestExpired = true;
	// 					}
	// 				}
	// 				this.procoreService.headerStatus = this.signature.status.toLowerCase();
	// 				if (this.signature.status.toLowerCase() !== 'cancelled') {
	// 					this.showCreateNewRequest = false;
	// 				}
	// 				if (signatureResult.signatures) {
	// 					this.userSignatures = signatureResult.signatures;
	// 					for (const signatureInfo of signatureResult.signatures) {
	// 						let isInternal = false;
	// 						for (const internalUser of this.internalUsers) {
	// 							if (signatureInfo.signer_email_address === internalUser.email) {
	// 								this.addSigner('internal', '');
	// 								this.updateInternalSigner(internalUser, this.form.getRawValue()['signersList'].length - 1);
	// 								isInternal = true;
	// 								break;
	// 							}
	// 						}
	// 						if (!isInternal) {
	// 							this.addSigner('external', '');
	// 							this.updateExternalSigner(signatureInfo.signer_email_address, signatureInfo.signer_name, this.form.getRawValue()['signersList'].length - 1);
	// 						}
	// 						this.existingSignatories.push({
	// 							'name': signatureInfo.signer_name,
	// 							'email': signatureInfo.signer_email_address,
	// 							'status': signatureInfo.status_code,
	// 							'viewedAt': signatureInfo.last_viewed_at
	// 						});
	// 					}
	// 					this.procoreService.getReminders(this.contextService.procoreContextObject.context.company_id, this.signature.signatureRequestId).subscribe((result: any[]) => {
	// 						this.reminders = result;
	// 					});
	// 				}
	// 			}
	// 			if (this.isSubmittal) {
	// 				this.loadSubmittal();
	// 			} else if (this.isRfi) {
	// 				this.loadRfi();
	// 			} else {
	// 				this.initialLoad = false;
	// 				this.loading = false;
	// 			}
	// 		});
	// 	});
	// }

	// loadSubmittal() {
	// 	if (this.signature) {
	// 		this.procoreService.getSignatureRequest(this.contextService.procoreContextObject.context.company_id, this.signature.signatureRequestId, this.contextService.procoreUserInfo.email).subscribe((signatureRequest: any) => {
	// 			for (const signer of signatureRequest.signatures) {
	// 				if (signer.signer_email_address === this.contextService.procoreUserInfo.email) {
	// 					this.isSigner = true;
	// 					break;
	// 				}
	// 			}
	// 		});
	// 	}
	// 	this.procoreService.getSubmittal(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreIsSandbox).subscribe((submittal: any) => {
	// 		this.isSubmittalManager = submittal.submittal_manager.login === this.contextService.procoreUserInfo.email;
	// 		if (this.signature) {
	// 			// for (const user of submittal.ball_in_court) {
	// 			// 	if (user.login === this.userInfo.email) {
	// 			// 		this.hasBallInCourt = true;
	// 			// 		break;
	// 			// 	}
	// 			// }
	// 			for (const signature of this.userSignatures) {
	// 				if (signature.status_code === 'awaiting_signature' && signature.signer_email_address === this.contextService.procoreUserInfo.email) {
	// 					this.hasBallInCourt = true;
	// 					break;
	// 				}
	// 			}
	// 		} else {
	// 			for (const approver of submittal.approvers) {
	// 				this.addSigner('internal', '');
	// 				const internalUser = {
	// 					email: approver.user.login,
	// 					name: approver.user.name
	// 				};
	// 				this.updateInternalSigner(internalUser, this.form.getRawValue()['signersList'].length - 1);
	// 			}
	// 		}
	// 		console.log(submittal);
	// 		this.initialLoad = false;
	// 		this.loading = false;
	// 	});
	// }

	// loadRfi() {
	// 	this.procoreService.getRfi(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreContextObject.context.id, this.contextService.procoreIsSandbox).subscribe((rfi: any) => {
	// 		this.isRfiManager = rfi.rfi_manager.login === this.contextService.procoreUserInfo.email;
	// 		if (!this.signature || this.signature.status === 'CANCELLED') {
	// 			for (const assignee of rfi.assignees) {
	// 				this.addSigner('internal', '');
	// 				const internalUser = {
	// 					email: assignee.login,
	// 					name: assignee.name
	// 				};
	// 				this.updateInternalSigner(internalUser, this.form.getRawValue()['signersList'].length - 1);
	// 			}
	// 		}
	// 		console.log(rfi);
	// 		this.initialLoad = false;
	// 		this.loading = false;
	// 	});
	// }



	/** SIGNER FUNCTIONS **/

	// addSigner(type: string, role: string) {
	// 	const signers = this.form.get('signersList') as UntypedFormArray;

	// 	if (!role) {
	// 		role = 'Signer' + (this.signerId + 1);
	// 	}

	// 	signers.push(this.fb.group({
	// 		signerType: [type, []],
	// 		signerId: [this.signerId, []],
	// 		signerEmail: [null, [Validators.email]],
	// 		signerName: ['', []],
	// 		role: [role, []]
	// 	}, {
	// 		validators: [
	// 			this.checkSigner()
	// 		]
	// 	}));

	// 	this.signerId = this.signerId + 1;
	// }

	addSigner(role: string) {
		const signers = this.form.get('signersList') as UntypedFormArray;

		if (!role) {
			role = 'Signer' + (this.signerId + 1);
		}

		signers.push(this.fb.group({
			signerId: [this.signerId, []],
			signerEmail: [null, [Validators.email]],
			signerName: ['', []],
			role: [role, []]
		}, {
			validators: [
				this.checkSigner()
			]
		}));

		this.signerId = this.signerId + 1;
	}

	checkSigner() {
		return (group: UntypedFormGroup) => {
			let signerValid = true;
			if (this.form) {
				signerValid = group.value.signerEmail && group.value.signerEmail.length > 0 && group.value.signerName && group.value.signerName.length > 0;
			}
			if (signerValid) {
				group.controls['signerEmail'].setErrors(null);
				group.controls['signerName'].setErrors(null);
				return '';
			} else {
				group.controls['signerEmail'].setErrors(Validators);
				group.controls['signerName'].setErrors(Validators);
				return {
					missing: true
				};
			}
		};
	}

	removeSigner(i: number) {
		const signers = this.form.get('signersList') as UntypedFormArray;

		//let prevSignerId;
		let prevRole;

		for (let index = 0; index < signers.length; index++) {
			if (index > i) {
				//let localPrevSignerId = signers.at(index).get('signerId').value;
				let localPrevRole = signers.at(index).get('role').value;

				//signers.at(index).get('signerId').patchValue(prevSignerId);
				signers.at(index).get('role').patchValue(prevRole);

				//prevSignerId = localPrevSignerId;
				prevRole = localPrevRole;
			} else {
				//prevSignerId = signers.at(index).get('signerId').value;
				prevRole = signers.at(index).get('role').value;
			}

		}

		signers.removeAt(i);
		console.log(signers);
	}

	moveSignerUp(i: number) {
		const signers = this.form.get('signersList') as UntypedFormArray;

		let signerBeingMoved = signers.at(i);
		//let signerBeingMovedSignerId = signerBeingMoved.get('signerId').value;
		let signerBeingMovedRole = signerBeingMoved.get('role').value;

		let signerBeingReplaced = signers.at(i - 1);
		//let signerBeingReplacedSignerId = signerBeingReplaced.get('signerId').value;
		let signerBeingReplacedRole = signerBeingReplaced.get('role').value;

		// Swap the signerId and role
		//signerBeingReplaced.get('signerId').patchValue(signerBeingMovedSignerId);
		signerBeingReplaced.get('role').patchValue(signerBeingMovedRole);

		//signerBeingMoved.get('signerId').patchValue(signerBeingReplacedSignerId);
		signerBeingMoved.get('role').patchValue(signerBeingReplacedRole);

		signers.removeAt(i);
		signers.insert(i - 1, signerBeingMoved);

		console.log(signers);
	}

	moveSignerDown(i: number) {
		const signers = this.form.get('signersList') as UntypedFormArray;

		let signerBeingMoved = signers.at(i);
		//let signerBeingMovedSignerId = signerBeingMoved.get('signerId').value;
		let signerBeingMovedRole = signerBeingMoved.get('role').value;

		let signerBeingReplaced = signers.at(i + 1);
		//let signerBeingReplacedSignerId = signerBeingReplaced.get('signerId').value;
		let signerBeingReplacedRole = signerBeingReplaced.get('role').value;

		// Swap the signerId and role
		//signerBeingReplaced.get('signerId').patchValue(signerBeingMovedSignerId);
		signerBeingReplaced.get('role').patchValue(signerBeingMovedRole);

		//signerBeingMoved.get('signerId').patchValue(signerBeingReplacedSignerId);
		signerBeingMoved.get('role').patchValue(signerBeingReplacedRole);

		signers.removeAt(i);
		signers.insert(i + 1, signerBeingMoved);

		console.log(signers);
	}

	validateCCs() {
		let isValid = true;
		for (const cc of this.ccList) {
			if (cc.email == '' || !this.validateEmail(cc.email)) {
				isValid = false;
				break;
			}
		}

		return isValid;
	}

	validateEmail(email) {
		return String(email)
			.toLowerCase()
			.match(
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			);
	}

	addCC() {
		let ccObj = {
			'number': 1,
			'email': ''
		};

		this.ccList.push(ccObj);
	}

	removeCC(position: number) {
		this.ccList.splice(position, 1);
	}

	updateCC(e: any, position: number) {
		console.log(e);
		this.ccList[position].email = e.target.value;
	}



	/** SUBMIT **/

	submitCancelAndResend() {
		this.loading = true;
		this.dropboxService.cancelRequest(this.signatures[0].clientSignature.signatureRequestId, this.contextService.procoreUserInfo.email, this.contextService.procoreContextObject.context.company_id, this.contextService.procoreIsSandbox).subscribe((response) => {
			this.submit();
		});
	}

	// This cancels the attempt to generate and launch the dropbox sign requesting tool
	submitCancel() {
		this.loading = false;
		this.loadingSubmit = false;
		this.loadingSubmitCancelled = true;
	}

	submit() {
		this.submitRetries = 0;
		this.showWaitingMessage = false;

		this.loading = true;
		this.loadingSubmit = true;
		this.loadingSubmitCancelled = false;

		const requestBody = this.form.getRawValue();
		if (this.selectedTemplate && this.selectedTemplate !== '') {
			requestBody['templateId'] = this.selectedTemplate.template_id;
			requestBody['templateName'] = this.selectedTemplate.title;
		}
		if (this.selectedTemplateOverlay) {
			requestBody['templateOverlayId'] = this.selectedTemplateOverlay.template_id;
			requestBody['templateOverlayName'] = this.selectedTemplateOverlay.title;
		}
		requestBody.attachments = [];
		for (const attachment of this.attachments) {
			if (attachment.checked) {
				requestBody.attachments.push(attachment.url);
			}
		}

		let ccString = '';
		for (const cc of this.ccList) {
			if (cc.email) {
				ccString = ccString + cc.email + ',';
			}
		}
		ccString = ccString.replace(/,$/, "");
		requestBody.ccEmails = ccString;

		if (!this.useGeneratedFile) {
			this.submitUploaded(requestBody);
		} else if (this.contextService.procoreContextObject.context.generatedFileType == 'coversheet') {
			this.submitGeneratedCoverSheetStart(requestBody);
		} else {
			this.submitGeneratedPDFStart(requestBody);
		}
	}

	submitUploaded(requestBody) {
		requestBody['generatedFileUrl'] = '';
		requestBody['generatedFileType'] = '';

		this.dropboxService.createEmbeddedRequest(this.uploadedDoc, requestBody, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, '')
			.subscribe({
				next: (response) => {
					console.log(response);
					this.requestSent = true;
					window.open('/?embedded=1&url=' + btoa(response.body) + '&companyId=' + this.contextService.procoreContextObject.context.company_id + '&projectId=' + this.contextService.procoreContextObject.context.project_id + '&context=' + this.contextService.procoreContextObject.context.id + '&isSandbox=' + this.contextService.procoreIsSandbox, '_blank');
					this.loading = false;
					this.loadingSubmit = false;
				},
				error: (err) => {
					console.log(err);
					if (err.error === 'Disabled') {
						this.errorResponse = 'The integration is currently disabled. You may contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to request more information.';
					} else if (err.error === 'No signatures remaining') {
						this.errorResponse = 'You currently do not have any signatures available. Contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to purchase additional signature packs.';
					} else if (err.status === 400) {
						this.errorResponse = 'An error occurred sending the file to Dropbox Sign.';
					} else if (err.status === 413) {
						this.errorResponse = 'Max file size is 40MB.';
					} else if (err.status === 204) {
						this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
					} else {
						this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
					}

					this.loading = false;
					this.loadingSubmit = false;
				}
			});
	}

	submitGeneratedCoverSheetStart(requestBody) {
		const fileContext = {
			companyId: this.contextService.procoreContextObject.context.company_id,
			projectId: this.contextService.procoreContextObject.context.project_id,
			itemId: this.contextService.procoreContextObject.context.id,
			route: this.contextService.procoreContextObject.context.route
		}

		this.procoreService.startGenerateFile(fileContext, this.contextService.procoreContextObject.context.view, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe({
				next: (startResponse) => {

					this.contextService.procoreContextObject.context.generatedFileUrl = startResponse;
					if (this.contextService.procoreContextObject.context.view == 'commitments.requisitions.detail' || this.contextService.procoreContextObject.context.view == 'invoicing.requisitions.detail' || this.contextService.procoreContextObject.context.view == 'prime_contracts.payment_applications' || this.contextService.procoreContextObject.context.view == 'invoicing.payment_applications.detail') {
						this.contextService.procoreContextObject.context.generatedFileType = "coversheet";
					} else {
						this.contextService.procoreContextObject.context.generatedFileType = "pdf";
					}

					if (this.useGeneratedFile) {
						requestBody['useGeneratedFile'] = true;
						requestBody['generatedFileUrl'] = this.contextService.procoreContextObject.context.generatedFileUrl;
						requestBody['generatedFileType'] = this.contextService.procoreContextObject.context.generatedFileType;
					}

					this.submitGeneratedCoverSheetFinish(requestBody, '');
				},
				error: () => {
					this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
					this.loading = false;
					this.loadingSubmit = false;
				}
			});

	}

	submitGeneratedCoverSheetFinish(requestBody, fileGenerationUuid) {
		this.submitRetries = this.submitRetries + 1;

		if (this.submitRetries < 2 && !this.loadingSubmitCancelled) {
			this.dropboxService.createEmbeddedRequest(this.uploadedDoc, requestBody, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, fileGenerationUuid)
				.subscribe({
					next: (response) => {
						console.log("submitGeneratedCoverSheetFinish response");
						console.log(response);
						let showMessage = true;
						if (response.status === 204) {
							// RETRY HERE:
							if (this.twoZeroFourRetries < 4) {
								this.twoZeroFourRetries++;
								showMessage = false;

								let _this = this;
								setTimeout(function () {
									_this.submit();
								}, 2000);
							} else {
								this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
							}
						} else if (response.status === 202) {
							showMessage = false;
							let _this = this;
							setTimeout(function () {
								_this.submitGeneratedCoverSheetFinish(requestBody, response.body);
							}, 4000);
						} else {
							showMessage = false;

							this.requestSent = true;
							window.open('/?embedded=1&url=' + btoa(response.body) + '&companyId=' + this.contextService.procoreContextObject.context.company_id + '&projectId=' + this.contextService.procoreContextObject.context.project_id + '&context=' + this.contextService.procoreContextObject.context.id + '&isSandbox=' + this.contextService.procoreIsSandbox, '_blank');
							this.loading = false;
							this.loadingSubmit = false;
							this.errorResponse = '';
						}
						if (showMessage) {
							this.loading = false;
							this.loadingSubmit = false;
						}
					},
					error: (err) => {
						console.log("submitGeneratedCoverSheetFinish error");
						console.log(err);
						let showMessage = true;
						if (err.error === 'Disabled') {
							this.errorResponse = 'The integration is currently disabled. You may contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to request more information.';
						} else if (err.error === 'No signatures remaining') {
							this.errorResponse = 'You currently do not have any signatures available. Contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to purchase additional signature packs.';
						} else if (err.status === 400) {
							this.errorResponse = 'An error occurred sending the file to Dropbox Sign.';

							// TODO: RETRY HERE


						} else if (err.status === 413) {
							this.errorResponse = 'Max file size is 40MB.';
						} else if (err.status === 204) {
							this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
						} else if (err.status === 202) {
							showMessage = false;
							let _this = this;
							setTimeout(function () {
								_this.submitGeneratedCoverSheetFinish(requestBody, err.body);
							}, 4000);
						} else {
							this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
						}

						if (showMessage) {
							this.loading = false;
							this.loadingSubmit = false;
						}
					}
				});
		} else if (this.submitRetries < 20 && !this.loadingSubmitCancelled) {
			this.showWaitingMessage = true;
			this.dropboxService.createEmbeddedRequest(this.uploadedDoc, requestBody, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, fileGenerationUuid)
				.subscribe({
					next: (response) => {
						console.log("submitGeneratedCoverSheetFinish response");
						console.log(response);
						let showMessage = true;
						if (response.status === 204) {
							// RETRY HERE:
							if (this.twoZeroFourRetries < 4) {
								this.twoZeroFourRetries++;
								showMessage = false;

								let _this = this;
								setTimeout(function () {
									_this.submit();
								}, 2000);
							} else {
								this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
							}
						} else if (response.status === 202) {
							showMessage = false;
							let _this = this;
							setTimeout(function () {
								_this.submitGeneratedCoverSheetFinish(requestBody, response.body);
							}, 4000);
						} else {
							showMessage = false;

							this.requestSent = true;
							window.open('/?embedded=1&url=' + btoa(response.body) + '&companyId=' + this.contextService.procoreContextObject.context.company_id + '&projectId=' + this.contextService.procoreContextObject.context.project_id + '&context=' + this.contextService.procoreContextObject.context.id + '&isSandbox=' + this.contextService.procoreIsSandbox, '_blank');
							this.loading = false;
							this.loadingSubmit = false;
							this.errorResponse = '';
						}
						if (showMessage) {
							this.loading = false;
							this.loadingSubmit = false;
						}
					},
					error: (err) => {
						console.log("submitGeneratedCoverSheetFinish error");
						console.log(err);
						let showMessage = true;
						if (err.error === 'Disabled') {
							this.errorResponse = 'The integration is currently disabled. You may contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to request more information.';
						} else if (err.error === 'No signatures remaining') {
							this.errorResponse = 'You currently do not have any signatures available. Contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to purchase additional signature packs.';
						} else if (err.status === 400) {
							this.errorResponse = 'An error occurred sending the file to Dropbox Sign.';

							// TODO: RETRY HERE


						} else if (err.status === 413) {
							this.errorResponse = 'Max file size is 40MB.';
						} else if (err.status === 204) {
							this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
						} else if (err.status === 202) {
							showMessage = false;
							let _this = this;
							setTimeout(function () {
								_this.submitGeneratedCoverSheetFinish(requestBody, err.body);
							}, 4000);
						} else {
							this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
						}

						if (showMessage) {
							this.loading = false;
							this.loadingSubmit = false;
						}
					}
				});
		} else if (this.loadingSubmitCancelled) {
			// Do nothing
		} else {
			this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
			this.loading = false;
			this.loadingSubmit = false;
		}
	}

	submitGeneratedPDFStart(requestBody) {
		const fileContext = {
			companyId: this.contextService.procoreContextObject.context.company_id,
			projectId: this.contextService.procoreContextObject.context.project_id,
			itemId: this.contextService.procoreContextObject.context.id,
			route: this.contextService.procoreContextObject.context.route
		}

		this.procoreService.startGenerateFile(fileContext, this.contextService.procoreContextObject.context.view, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId)
			.subscribe({
				next: (startResponse) => {

					this.contextService.procoreContextObject.context.generatedFileUrl = startResponse;
					if (this.contextService.procoreContextObject.context.view == 'commitments.requisitions.detail' || this.contextService.procoreContextObject.context.view == 'invoicing.requisitions.detail' || this.contextService.procoreContextObject.context.view == 'prime_contracts.payment_applications' || this.contextService.procoreContextObject.context.view == 'invoicing.payment_applications.detail') {
						this.contextService.procoreContextObject.context.generatedFileType = "coversheet";
					} else {
						this.contextService.procoreContextObject.context.generatedFileType = "pdf";
					}

					if (this.useGeneratedFile) {
						requestBody['useGeneratedFile'] = true;
						requestBody['generatedFileUrl'] = this.contextService.procoreContextObject.context.generatedFileUrl;
						requestBody['generatedFileType'] = this.contextService.procoreContextObject.context.generatedFileType;
					}

					this.submitGeneratedPDFFinish(requestBody, '');
				},
				error: () => {
					this.loading = false;
					this.loadingSubmit = false;
				}
			});
	}

	submitGeneratedPDFFinish(requestBody, fileGenerationUuid) {
		this.submitRetries = this.submitRetries + 1;

		if (this.submitRetries < 2 && !this.loadingSubmitCancelled) {
			this.dropboxService.createEmbeddedRequest(this.uploadedDoc, requestBody, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, fileGenerationUuid)
				.subscribe({
					next: (response) => {
						console.log("submitGeneratedPDFFinish response");
						console.log(response);

						let showMessage = true;
						// if (err.error === 'Disabled') {
						// 	this.errorResponse = 'The integration is currently disabled. You may contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to request more information.';
						// } else if (err.error === 'No signatures remaining') {
						// 	this.errorResponse = 'You currently do not have any signatures available. Contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to purchase additional signature packs.';
						// } else if (err.status === 400) {
						// 	this.errorResponse = 'An error occurred sending the file to Dropbox Sign.';
						// } else if (err.status === 413) {
						// 	this.errorResponse = 'Max file size is 40MB.';
						// } else 

						if (response.status === 204) {
							// RETRY HERE:
							if (this.twoZeroFourRetries < 4) {
								this.twoZeroFourRetries++;
								showMessage = false;

								let _this = this;
								setTimeout(function () {
									_this.submit();
								}, 2000);
							} else {
								this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
							}
						} else if (response.status === 202) {
							showMessage = false;
							let _this = this;
							setTimeout(function () {
								_this.submitGeneratedPDFFinish(requestBody, response.body);
							}, 4000);
						} else {
							showMessage = false;

							this.requestSent = true;
							window.open('/?embedded=1&url=' + btoa(response.body) + '&companyId=' + this.contextService.procoreContextObject.context.company_id + '&projectId=' + this.contextService.procoreContextObject.context.project_id + '&context=' + this.contextService.procoreContextObject.context.id + '&isSandbox=' + this.contextService.procoreIsSandbox, '_blank');
							this.loading = false;
							this.loadingSubmit = false;
							this.errorResponse = '';
						}

						if (showMessage) {
							this.loading = false;
							this.loadingSubmit = false;
						}





						// if (response === 'PDF is not ready') {
						// 	console.log('PDF is not ready');

						// 	let _this = this;
						// 	setTimeout(function () {
						// 		_this.submitGeneratedPDFFinish(requestBody, response);
						// 	}, 4000);
						// } else {
						// 	console.log(response);
						// 	this.requestSent = true;
						// 	window.open('/?embedded=1&url=' + btoa(response) + '&companyId=' + this.contextService.procoreContextObject.context.company_id + '&projectId=' + this.contextService.procoreContextObject.context.project_id + '&context=' + this.contextService.procoreContextObject.context.id + '&isSandbox=' + this.contextService.procoreIsSandbox, '_blank');
						// 	this.loading = false;
						// 	this.loadingSubmit = false;
						// }


					},
					error: (err) => {
						console.log("submitGeneratedPDFFinish err");
						console.log(err);

						let showMessage = true;
						if (err.error === 'Disabled') {
							this.errorResponse = 'The integration is currently disabled. You may contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to request more information.';
						} else if (err.error === 'No signatures remaining') {
							this.errorResponse = 'You currently do not have any signatures available. Contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to purchase additional signature packs.';
						} else if (err.status === 400) {
							this.errorResponse = 'An error occurred sending the file to Dropbox Sign.';
						} else if (err.status === 413) {
							this.errorResponse = 'Max file size is 40MB.';
						} else if (err.status === 204) {
							this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
							// } else if (err.status === 202) {
							// 	showMessage = false;
							// 	let _this = this;
							// 	setTimeout(function () {
							// 		_this.submitGeneratedPDFFinish(requestBody);
							// 	}, 4000);
						} else {
							this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
						}

						if (showMessage) {
							this.loading = false;
							this.loadingSubmit = false;
						}
					}
				});
		} else if (this.submitRetries < 20 && !this.loadingSubmitCancelled) {
			this.showWaitingMessage = true;
			this.dropboxService.createEmbeddedRequest(this.uploadedDoc, requestBody, this.contextService.procoreIsSandbox, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, fileGenerationUuid)
				.subscribe({
					next: (response) => {
						console.log("submitGeneratedPDFFinish response");
						console.log(response);

						let showMessage = true;
						// if (err.error === 'Disabled') {
						// 	this.errorResponse = 'The integration is currently disabled. You may contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to request more information.';
						// } else if (err.error === 'No signatures remaining') {
						// 	this.errorResponse = 'You currently do not have any signatures available. Contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to purchase additional signature packs.';
						// } else if (err.status === 400) {
						// 	this.errorResponse = 'An error occurred sending the file to Dropbox Sign.';
						// } else if (err.status === 413) {
						// 	this.errorResponse = 'Max file size is 40MB.';
						// } else 

						if (response.status === 204) {
							// RETRY HERE:
							if (this.twoZeroFourRetries < 4) {
								this.twoZeroFourRetries++;
								showMessage = false;

								let _this = this;
								setTimeout(function () {
									_this.submit();
								}, 2000);
							} else {
								this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
							}
						} else if (response.status === 202) {
							showMessage = false;
							let _this = this;
							setTimeout(function () {
								_this.submitGeneratedPDFFinish(requestBody, response.body);
							}, 4000);
						} else {
							showMessage = false;

							this.requestSent = true;
							window.open('/?embedded=1&url=' + btoa(response.body) + '&companyId=' + this.contextService.procoreContextObject.context.company_id + '&projectId=' + this.contextService.procoreContextObject.context.project_id + '&context=' + this.contextService.procoreContextObject.context.id + '&isSandbox=' + this.contextService.procoreIsSandbox, '_blank');
							this.loading = false;
							this.loadingSubmit = false;
						}

						if (showMessage) {
							this.loading = false;
							this.loadingSubmit = false;
						}





						// if (response === 'PDF is not ready') {
						// 	console.log('PDF is not ready');

						// 	let _this = this;
						// 	setTimeout(function () {
						// 		_this.submitGeneratedPDFFinish(requestBody, response);
						// 	}, 4000);
						// } else {
						// 	console.log(response);
						// 	this.requestSent = true;
						// 	window.open('/?embedded=1&url=' + btoa(response) + '&companyId=' + this.contextService.procoreContextObject.context.company_id + '&projectId=' + this.contextService.procoreContextObject.context.project_id + '&context=' + this.contextService.procoreContextObject.context.id + '&isSandbox=' + this.contextService.procoreIsSandbox, '_blank');
						// 	this.loading = false;
						// 	this.loadingSubmit = false;
						// }


					},
					error: (err) => {
						console.log("submitGeneratedPDFFinish err");
						console.log(err);

						let showMessage = true;
						if (err.error === 'Disabled') {
							this.errorResponse = 'The integration is currently disabled. You may contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to request more information.';
						} else if (err.error === 'No signatures remaining') {
							this.errorResponse = 'You currently do not have any signatures available. Contact <a href=\'mailto:dbsc.support@shakeit.ai\'>dbsc.support@shakeit.ai</a> to purchase additional signature packs.';
						} else if (err.status === 400) {
							this.errorResponse = 'An error occurred sending the file to Dropbox Sign.';
						} else if (err.status === 413) {
							this.errorResponse = 'Max file size is 40MB.';
						} else if (err.status === 204) {
							this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
							// } else if (err.status === 202) {
							// 	showMessage = false;
							// 	let _this = this;
							// 	setTimeout(function () {
							// 		_this.submitGeneratedPDFFinish(requestBody);
							// 	}, 4000);
						} else {
							this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
						}

						if (showMessage) {
							this.loading = false;
							this.loadingSubmit = false;
						}
					}
				});
		} else if (this.loadingSubmitCancelled) {
			// Do nothing
		} else {
			this.errorResponse = 'There was an issue generating the file. Please try again. If this continues, you can manually export the file and attach it to continue.';
			this.loading = false;
			this.loadingSubmit = false;
		}
	}

	// For submittals
	// submitSignatureRequest() {
	// 	this.loading = true;
	// 	const requestBody = this.form.getRawValue();
	// 	requestBody['templateId'] = this.selectedTemplate.template_id;
	// 	requestBody.attachments = [];
	// 	for (const attachment of this.attachments) {
	// 		if (attachment.checked) {
	// 			requestBody.attachments.push(attachment.url);
	// 		}
	// 	}

	// 	this.procoreService.createEmbeddedSignatureRequest(this.uploadedDoc, requestBody, this.contextService.procoreIsSandbox).subscribe((result: string) => {
	// 		console.log(result);
	// 		this.requestSent = true;
	// 		this.loading = false;
	// 	});
	// }

	// For submittals
	// signSignatureRequest() {
	// 	let signatureRequestId: string;

	// 	for (const signature of this.userSignatures) {
	// 		if (signature.status_code === 'awaiting_signature' && signature.signer_email_address === this.contextService.procoreUserInfo.email) {
	// 			signatureRequestId = signature.signature_id;
	// 			break;
	// 		}
	// 	}

	// 	if (signatureRequestId) {
	// 		this.procoreService.getSignatureRequestSignUrl(this.contextService.procoreContextObject.context.company_id, signatureRequestId, this.contextService.procoreUserInfo.email).subscribe((result: any) => {
	// 			window.open('/?embedded-sign=1&url=' + btoa(result.url) + '&clientId=' + result.clientId, '_blank');
	// 		});
	// 	}
	// }

	/** FILE FUNCTIONS **/

	setLoadingGeneratedFile(loadingGeneratedFile) {
		this.loadingGeneratedFile = loadingGeneratedFile;
	}

	setUploadedDoc(uploadedDoc) {
		this.uploadedDoc = uploadedDoc;
	}

	setUseGeneratedFile(useGeneratedFile) {
		this.useGeneratedFile = useGeneratedFile;
	}

	/** OTHER ACTIONS **/

	logoutUser() {
		this.loadingUserLogout = true;


		this.clientService.deleteUser(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, this.contextService.procoreUserInfo.email, this.contextService.procoreIsSandbox).subscribe((response: any) => {
			if (response == true) {
				this.router.navigate(['/']);



				// let item = this.users.find(d => d.userName === user.userName);
				// if (item) {
				// 	this.users.splice(this.users.indexOf(item), 1);
				// }

			}
			// this.userToDelete = null;
		});
	}

	launchBillingPortal() {
		if (!this.loadingLaunchBillingPortal) {
			this.loadingLaunchBillingPortal = true;
			this.stripeService.getStripeBillingPortalLink(this.contextService.procoreContextObject.context.company_id)
				.subscribe(
					(response: any) => {
						this.loadingLaunchBillingPortal = false;
						this.showMenuExpanded = false;
						window.open(response, '_blank');
					}
				);
		}
	}

	launchSignaturesDashboard() {
		if (!this.loadingLaunchDashboard) {
			this.loadingLaunchDashboard = true;
			this.dashboardService.getDashboardToken(this.contextService.procoreContextObject.context.company_id, this.contextService.procoreContextObject.context.project_id, this.contextService.procoreUserInfo.email, this.contextService.procoreUserInfo.procoreUserId, this.contextService.procoreIsSandbox, 'DBS for Procore')
				.subscribe((response: any) => {
					this.loadingLaunchDashboard = false;
					this.showMenuExpanded = false;
					window.open('/signatures?uuid=' + response, '_blank');
				});
		}
	}

	trackSigners(i: number, signer: any) {
		return signer.signerId;
	}

	updateSigner(e: any, i: number) {
		const signers = this.form.get('signersList') as UntypedFormArray;
		const signer: any = signers.at(i);

		if (e) {
			console.log(e);
			console.log(signer);
			if (e.email) {
				signer.controls.signerEmail.setValue(e.email, { emitEvent: true });
			}
			signer.controls.signerName.setValue(e.name, { emitEvent: true });
		} else {
			console.log(signer.controls.signerName);
			signer.controls.signerEmail.setValue('', { emitEvent: true });
			signer.controls.signerName.setValue('', { emitEvent: true });
		}
	}

	// updateInternalSigner(e: any, i: number) {
	// 	const signers = this.form.get('signersList') as UntypedFormArray;
	// 	const signer: any = signers.at(i);
	// 	signer.controls.signerEmail.setValue(e.email, { emitEvent: true });
	// 	signer.controls.signerName.setValue(e.name, { emitEvent: true });
	// }

	// updateExternalSigner(email: string, name: string, i: number) {
	// 	const signers = this.form.get('signersList') as UntypedFormArray;
	// 	const signer: any = signers.at(i);
	// 	signer.controls.signerEmail.setValue(email, { emitEvent: true });
	// 	signer.controls.signerName.setValue(name, { emitEvent: true });
	// }

	/** HELPER FUNCTIONS **/

	fileUploaded(e: any) {
		console.log(e);

		if (e.target) {
			this.uploadedDoc = e.target.files[0];
		} else {
			this.uploadedDoc = e[0];
		}

		console.log(this.uploadedDoc);
		this.showDragDropBorder = false;
	}

	fileCleared() {
		this.uploadedDoc = null;
		this.useGeneratedFile = false;
	}

	requestCancelled(signature) {
		let item = this.signatures.find(d => d === signature);
		if (item) {
			item.clientSignature.status = 'CANCELLED';
			item.signatures = null;
		}
	}

	showConfigureForm() {
		this.showMenuExpanded = false;
		this.showConfigure = true;
		this.showConfigureUser = false;
	}

	exitConfiguration(didSave) {
		if (didSave) {
			// TODO: Show some type of success indicator
		}

		this.showConfigure = false;
	}

	showConfigureUserForm() {
		this.showMenuExpanded = false;
		this.showConfigure = false;
		this.showConfigureUser = true;
	}

	exitConfigurationUser(didSave) {
		if (didSave) {
			// TODO: Show some type of success indicator
		}

		this.showConfigureUser = false;
	}

	setDefaultProjectConfigs() {
		this.projectConfigs = {
			allowDefaultLocationOverride: false,
			primeContractStorage: 'default',
			primeContractCoStorage: 'default',
			primeContractPcoStorage: 'default',
			subcontractStorage: 'default',
			subcontractCoStorage: 'default',
			subcontractPcoStorage: 'default',
			purchaseOrderStorage: 'default',
			purchaseOrderCoStorage: 'default',
			purchaseOrderPcoStorage: 'default'
		};
	}

	populateFolderOptions(folder: any, depth: number) {
		this.folderOptions.push({
			id: folder.id,
			name: '-'.repeat(depth) + folder.name
		});
		if (folder.children) {
			for (const child of folder.children) {
				this.populateFolderOptions(child, depth + 1);
			}
		}
	}

	setTemplates(templates) {
		this.templates = templates;

		let attemptContractSigner = false;
		if (this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlays && this.contextService.procoreContextObject.context.view == 'commitments.work_order_contracts.detail') {
			// Commitment Subcontract
			let templateId = this.contextService.clientDetailProcore.defaultRequestTemplateCommitmentSubcontract;
			if (templateId) {
				let template = this.templates.find(d => d.template_id === templateId);
				if (template) {
					this.setSelectedTemplateOverlay(template);
				} else {
					attemptContractSigner = true;
				}
			} else {
				attemptContractSigner = true;
			}
		} else if (this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlays && (this.contextService.procoreContextObject.context.view == 'commitments.potential_change_orders.detail' || this.contextService.procoreContextObject.context.view == 'commitments.commitment_contract_change_orders_batches.detail') && this.contextService.procoreContextObject.context.route.includes('work_order_contracts')) {
			// Commitment Subcontract Change Order
			let templateId = this.contextService.clientDetailProcore.defaultRequestTemplateCommitmentSubcontractChangeOrder;
			if (templateId) {
				let template = this.templates.find(d => d.template_id === templateId);
				if (template) {
					this.setSelectedTemplateOverlay(template);
				} else {
					attemptContractSigner = true;
				}
			} else {
				attemptContractSigner = true;
			}
		} else if (this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlays && this.contextService.procoreContextObject.context.view == 'commitments.purchase_order_contracts.detail') {
			// Commitment Purchase Order
			let templateId = this.contextService.clientDetailProcore.defaultRequestTemplateCommitmentPurchaseOrder;
			if (templateId) {
				let template = this.templates.find(d => d.template_id === templateId);
				if (template) {
					this.setSelectedTemplateOverlay(template);
				} else {
					attemptContractSigner = true;
				}
			} else {
				attemptContractSigner = true;
			}
		} else if (this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlays && (this.contextService.procoreContextObject.context.view == 'commitments.potential_change_orders.detail' || this.contextService.procoreContextObject.context.view == 'commitments.commitment_contract_change_orders_batches.detail') && this.contextService.procoreContextObject.context.route.includes('purchase_order_contracts')) {
			// Commitment Purchase Order Change Order
			let templateId = this.contextService.clientDetailProcore.defaultRequestTemplateCommitmentPurchaseOrderChangeOrder;
			if (templateId) {
				let template = this.templates.find(d => d.template_id === templateId);
				if (template) {
					this.setSelectedTemplateOverlay(template);
				} else {
					attemptContractSigner = true;
				}
			} else {
				attemptContractSigner = true;
			}
		} else if (this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlays && this.contextService.procoreContextObject.context.view == 'prime_contracts.detail') {
			// Prime Contract
			let templateId = this.contextService.clientDetailProcore.defaultRequestTemplatePrimeContract;
			if (templateId) {
				let template = this.templates.find(d => d.template_id === templateId);
				if (template) {
					this.setSelectedTemplateOverlay(template);
				} else {
					attemptContractSigner = true;
				}
			} else {
				attemptContractSigner = true;
			}
		} else if (this.contextService.clientDetailProcore.enableDropboxSignTemplateOverlays && (this.contextService.procoreContextObject.context.view == 'prime_contracts.prime_contracts_change_orders.detail' || this.contextService.procoreContextObject.context.view == 'prime_contracts.prime_contracts_change_orders_batches.detail')) {
			// Prime Contract Change Order
			let templateId = this.contextService.clientDetailProcore.defaultRequestTemplatePrimeContractChangeOrder;
			if (templateId) {
				let template = this.templates.find(d => d.template_id === templateId);
				if (template) {
					this.setSelectedTemplateOverlay(template);
				} else {
					attemptContractSigner = true;
				}
			} else {
				attemptContractSigner = true;
			}
		} else {
			attemptContractSigner = true;
		}

		if (attemptContractSigner = true) {
			if (this.contextService.clientDetailProcore.addContractSigner) {
				this.retrieveContractSigner();
			} else {
				this.loadingContractSigner = false;
			}
		}
	}

	setSelectedTemplate(template) {
		this.selectedTemplate = template;

		if (this.selectedTemplate !== '') {
			this.unsetSelectedTemplateOverlay();

			// Add signers based on the template
			const templateId = template.template_id;
			if (templateId) {
				for (const template of this.templates) {
					if (template.template_id === templateId) {
						for (const role of template.signer_roles) {
							this.addSigner(role.name);
						}
						break;
					}
				}
			}
		} else {
			// Remove any previously added signers if there is no templateOverlay set
			if (!this.selectedTemplateOverlay) {
				while (this.form.getRawValue()['signersList'].length > 0) {
					this.removeSigner(0);
				}
			}
		}
	}

	setSelectedTemplateOverlay(template) {
		this.selectedTemplateOverlay = template;
		this.showTemplateOverlaysExpanded = false;

		// Remove any previously added signers
		while (this.form.getRawValue()['signersList'].length > 0) {
			this.removeSigner(0);
		}

		const templateId = template.template_id;
		if (templateId) {
			for (const template of this.templates) {
				if (template.template_id === templateId) {
					// Add signers based on the template
					for (const role of template.signer_roles) {
						this.addSigner(role.name);
					}

					// Add CC based on the template
					if (template.cc_roles.length > 0) {
						this.ccList = [];
						for (const role of template.cc_roles) {
							let ccObj = {
								'number': 1,
								'email': role.name
							};

							this.ccList.push(ccObj);
						}
					} else {
						this.retrieveDefaultCC();
					}

					break;
				}
			}
		}

		if (this.contextService.clientDetailProcore.addContractSigner) {
			this.retrieveContractSigner();
		} else {
			this.loadingContractSigner = false;
		}
	}

	unsetSelectedTemplateOverlay() {
		this.selectedTemplateOverlay = null;
		this.showTemplateOverlaysExpanded = false;

		// Remove any previously added signers
		while (this.form.getRawValue()['signersList'].length > 0) {
			this.removeSigner(0);
		}

		this.retrieveDefaultCC();
	}

	getDefaultFileLocation() {
		let location = 'default';
		let configName = '';

		if (this.contextService.procoreContextObject.context.view.indexOf('prime_contracts.potential_change_orders') > -1) {
			configName = 'primeContractPcoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('prime_contracts.change_orders') > -1) {
			configName = 'primeContractCoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('prime_contracts') > -1) {
			configName = 'primeContractStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('work_order_contracts.potential_change_orders') > -1) {
			configName = 'subcontractPcoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('work_order_contracts.change_orders') > -1) {
			configName = 'subcontractCoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('work_order_contracts') > -1) {
			configName = 'subcontractStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('purchase_order_contracts.potential_change_orders') > -1) {
			configName = 'purchaseOrderPcoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('purchase_order_contracts.change_orders') > -1) {
			configName = 'purchaseOrderCoStorage';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('purchase_order_contracts') > -1) {
			configName = 'purchaseOrderStorage';
		}

		if (configName && this.projectConfigs[configName]) {
			location = this.projectConfigs[configName];
		}

		return location;
	}



	getDefaultFileLocationLabel() {
		let label = '';

		if (this.contextService.procoreContextObject.context.view.indexOf('prime_contracts') > -1) {
			label = 'Prime Contract';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('work_order_contracts') > -1) {
			label = 'Subcontract';
		} else if (this.contextService.procoreContextObject.context.view.indexOf('purchase_order_contracts') > -1) {
			label = 'Purchase Order';
		}

		return label;
	}

	getExpirationMinDate() {
		const date = new Date();
		date.setDate(date.getDate() + 2);
		const year = date.getFullYear();
		let month: any = date.getMonth() + 1;
		if (month < 10) {
			month = '0' + month;
		}
		let day: any = date.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		return year + '-' + month + '-' + day;
	}

	getExpirationMaxDate() {
		const date = new Date();
		date.setDate(date.getDate() + 90);
		const year = date.getFullYear();
		let month: any = date.getMonth() + 1;
		if (month < 10) {
			month = '0' + month;
		}
		let day: any = date.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		return year + '-' + month + '-' + day;
	}

	isFileTypeValid(filename) {
		console.log(filename);
		if (filename) {

			// if (['doc', 'docx', 'pdf', 'ppsx', 'ppt', 'pptx', 'jpg', 'jpeg', 'png', 'xls', 'xlsx', 'txt', 'html', 'gif']) {

			// }

			let extension = filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
			console.log(extension);

			const validExtensions = new Set(['doc', 'docx', 'pdf', 'ppsx', 'ppt', 'pptx', 'jpg', 'jpeg', 'png', 'xls', 'xlsx', 'txt', 'html', 'gif'])
			const isItemInSet = validExtensions.has(extension)

			if (isItemInSet) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	}

	openUserGuide() {
		window.open('https://procore-dbs.shakeit.ai/docs/user-guide/introduction', '_blank');

		this.showMenuExpanded = false;
	}

	calculateSignersCount() {
		return this.form.getRawValue()['signersList'].length;
	}

	calculateCCsCount() {
		return this.ccList.length;
	}

	calculateAttachmentsCount() {
		let count = 0;
		for (const attachment of this.attachments) {
			if (attachment.checked) {
				count++;
			}
		}
		return count;
	}

	calculateOptionsCount() {
		let count = 0;
		if (this.form.getRawValue()['allowDecline']) {
			count++;
		}
		if (this.form.getRawValue()['allowReassign']) {
			count++;
		}
		if (this.form.getRawValue()['expirationDate']) {
			count++;
		}

		return count;
	}


}
